export function agentModelOptions(models, defaultModel, savedModel) {
  const list = models || [];
  const defaultEntry = list.find((m) => m.id === defaultModel);
  const options = [{ value: "", label: "Flow default", disabled: !defaultEntry || !(defaultEntry.available || defaultEntry.retryable) },
    ...list.map((m) => ({ value: m.id, label: m.retryable && !m.available ? `${m.label} (will retry connection)` : m.label, disabled: !(m.available || m.retryable) }))];
  if (savedModel && !options.some((m) => m.value === savedModel)) {
    options.push({ value: savedModel, label: savedModel, disabled: true });
  }
  return options;
}

// "" = the model's own default. A started session's saved effort stays visible
// even if the list no longer offers it.
export function agentEffortOptions(model, savedEffort) {
  const efforts = (model && model.efforts) || [];
  const defaultLabel = model && model.defaultEffort ? `Default (${model.defaultEffort})` : "Default";
  const options = [{ value: "", label: defaultLabel }, ...efforts.map((e) => ({ value: e, label: e }))];
  if (savedEffort && !options.some((o) => o.value === savedEffort)) {
    options.push({ value: savedEffort, label: savedEffort });
  }
  return options;
}

export function sessionCost(session) {
  const turns = (session && session.turns) || [];
  if (!turns.length) return null;
  const values = turns.map((turn) => turn.stats && turn.stats.totalCostUsd);
  if (values.some((value) => typeof value !== "number")) return null;
  return values.reduce((sum, value) => sum + value, 0);
}
